import cache from "../../utils/cache";
import apis from "../../request/apis";

export default {
    namespaced: true,
    state: {
        userinfo: cache.getLocal("userinfo") || {}, //用户信息
        guestinfo: cache.getLocal("guestinfo") || {}, //游客信息

        user_id: cache.getLocal("user_id") || null,
        client_user_id: cache.getSession("client_user_id") || null,
    },

    mutations: {
        changeUserinfo(state, payload={}) {
            const fullInfo = { ...payload, 
              // ...(payload.detail||{})
             };
            state.userinfo = fullInfo;
            cache.setLocal("userinfo", state.userinfo, 604800000);
            // 存在用户token与id，视为登录，反正即时退出登录
            if(state.userinfo.access_token && state.userinfo.user_id) {
                window._paq.push(['setUserId', state.userinfo.user_id]);
                window._paq.push(['trackPageView']);
            }else {
                window._paq.push(['resetUserId']);
                window._paq.push(['appendToTrackingUrl', 'new_visit=1']);
                window._paq.push(['trackPageView']);
            }
        },
        changeGuestToken(state, payload) {
            state.guestinfo = payload;
            cache.setLocal("guestinfo", state.guestinfo, 7200000);
            // 更新游客token，即为游客登录
            if(state.guestinfo.access_guest_token) {
                window._paq.push(['resetUserId']);
                window._paq.push(['appendToTrackingUrl', 'new_visit=1']);
                window._paq.push(['trackPageView']);
            }
        },
        saveUserId(state, payload) {
            state.user_id = payload;
            cache.setLocal("user_id", state.user_id)
        },
        saveClientUserId(state, payload) {
            state.client_user_id = payload;
            cache.setSession("client_user_id", state.client_user_id)
        }
    },

    actions: {
        getClientGuestToken(store, params) {
            return new Promise((resolve, reject) => {
                apis.login.getClientGuestToken(params).then(res => {
                    store.commit("changeGuestToken", res.data);
                    resolve();
                }).catch(reject);
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js